module.exports = ".errormessage {\r\n    color: #fff !important;\r\n    text-transform: capitalize;\r\n    font-size: 13px;} "